import { AllyBase } from "../base";
import { AllyElementBase } from "./ally-element-base.class";

/**
 * --- This class provides part of the function matrix created by the AllyElements object. ---
 * 
 * This class creates a path for each node managed by an AllyObject object.
 * 
 * The path is dependent on the DOM structure as represented by AllyObject["parentObject"] and AllyObject["childObjects"].
 * 
 * @extends AllyElementBase
 * @see AllyElements
 */
export class AllyPath extends AllyElementBase {
    /**
     * @param bridge The bridge to the parent in the hierarchical tree.
     * @see AllyBase
     */
    constructor(bridge: () => AllyBase) {
        super(bridge, (matrix) => {
            matrix[1].push((scope) => {
                if (scope.self.parentObject && scope.self.parentObject.variables.path) {
                    scope.self.variables.path = [...scope.self.parentObject.variables.path];
                } else {
                    scope.self.variables.path = [];
                }
                if (scope.self.node.localName) {
                    scope.self.variables.path.push(scope.self.node.localName);
                }
                scope.self.node.setAttribute && scope.self.node.setAttribute("adx-ally-path", scope.self.variables.path!.join("/"));
            });
        }, 5);
    }
}